module.exports = __webpack_public_path__ + "img/groceries-benchmark-icons.d6866225.svg";